import { Button, Image, message, Table } from "antd";
import React, { useEffect } from "react";
import api from "../../api/api";
import styled from "styled-components";
import { IconLeft, IconRight } from "../../assets/icons";
import { useNavigate } from "react-router-dom";
import { PRIVATE_ROUTE } from "../../route.constants";
import { render } from "@testing-library/react";

export const Topbar = styled.div`
  padding-top: 8px;
  padding-bottom: 24px;
  display: flex;
  gap: 18px;
  align-items: center;
  justify-content: center;

  .ant-btn-default {
    height: 48px;
    padding: 0 12px !important;
    border: none !important;
    background: ${(props) => props.theme.backgroundColor} !important;
    color: ${(props) => props.theme.primaryColor} !important;
  }

  .ant-btn-primary {
    width: 172px;
    height: 48px;
  }
`;

export const TitleWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: #1d1014;
  line-height: 1;
`;

export const GrayTitle = styled(Title)`
  color: #868686;
`;

const BestSellingProducts = () => {
  const navigate = useNavigate();
  const [data, setData] = React.useState();
  useEffect(() => {
    getTopProducts();
  }, []);
  const getTopProducts = () => {
    api
      .getTopProducts()
      .then(({ data }) => {
        setData(data);
      })
      .catch((err) => {
        message.error(err);
      });
  };
  console.log(data);
  const goBack = () => {
    navigate(-1);
  };
  const columns = [
    {
      title: "No.",
      dataIndex: "key",
      key: "key",
      width: 50,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Product",
      dataIndex: "product",
      key: "product",
      render: (_, record, index) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* Product Image */}
          <Image
            src={record.image}
            alt="Product Image"
            style={{ width: 50, height: 50, marginRight: 10, borderRadius: 4 }}
          />
          {/* Product Name */}
          <span>{record.product_name.primary}</span>
        </div>
      ),
    },
    {
      title: "Variants",
      dataIndex: "variant_count",
      key: "variant_count",
      render: (_, record) =>
        record?.variants?.combination ? (
          <span>
            {Object.entries(record?.variants?.combination)
              .map(([key, value]) => value)
              .join(", ")}
          </span>
        ) : (
          <span>-</span>
        ),
    },
    {
      title: "Categories",
      dataIndex: "categories",
      key: "categories",
      render: (_, record) => (
        <span>
          {record.category.name.primary} / {record.sub_category.name.primary}
        </span>
      ),
    },
    {
      title: "Catalogues",
      dataIndex: "catalogues",
      key: "catalogues",
      render: (_, record) => (
        <span>
          {record.catalogues.map((catalogue, idx) => (
            <span key={idx}>
              {catalogue.name.primary}
              {idx !== record.catalogues.length - 1 ? ", " : ""}
            </span>
          ))}
        </span>
      ),
    },
    {
      title: "Total Orders",
      dataIndex: "total_orders",
      key: "total_orders",
    },
    {
      key: "actions",
      title: "Actions",
      // align: "right",
      render: (_, record) => (
        <IconRight
          style={{ cursor: "pointer" }}
          onClick={() => goToDetails(record)}
        />
      ),
    },
  ];
  const goToDetails = (item) => {
    navigate(
      `/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.PRODUCT_DETAILS}/${item.product_id}`
    );
  };
  return (
    <div>
      <Topbar>
        <Button type="default" icon={<IconLeft />} onClick={goBack}>
          Back
        </Button>
        <TitleWrapper>
          <GrayTitle>Dashboard</GrayTitle>
          <IconRight />
          <Title>Top Selling Products</Title>
        </TitleWrapper>
      </Topbar>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="key"
        pagination={false}
        size="middle"
      />
    </div>
  );
};

export default BestSellingProducts;
